import {hostConfig} from '../../config'
export function getImgPath (path) {
  if (!path) {
    return '/'
  } else if (path === '') {
    return '/'
  } else if (path.startsWith('blob:')) {
    return path
  } else if (path.search('http:') !== -1) {
    return path
  } else if (path.startsWith('/lab_lijian')) {
    return hostConfig.imgHost + '/lab_lijian' + path.split('/lab_lijian')[1]
  } else {
    return require('@/assets' + path.split('/assets')[1])
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js